import { css } from '@bts-web/utils-style-engine';

export const MoonIcon = ({
  active,
  activeColorToken = 'brand.fill_primary',
  ariaLabel,
  onClick,
}: {
  active: boolean;
  activeColorToken?: string;
  ariaLabel: string;
  onClick?: () => void;
}) => (
  <span
    className={css({
      display: 'inline-flex',
      alignItems: 'center',
      justifyContent: 'center',
      width: 32,
      height: 32,
      cursor: onClick ? 'pointer' : undefined,
      color: active ? activeColorToken : 'neutrals.text_secondary',
    })}
    data-element="icon"
    aria-label={ariaLabel}
    onClick={onClick}
  >
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      {active && (
        <path
          d="M0 16C0 7.16344 7.16344 0 16 0C24.8366 0 32 7.16344 32 16C32 24.8366 24.8366 32 16 32C7.16344 32 0 24.8366 0 16Z"
          fill="currentColor"
        />
      )}
      <path
        d="M15.4563 10C18.77 10 21.4563 12.6863 21.4563 16C21.4563 19.3137 18.77 22 15.4563 22C13.075 22 11.0187 20.6128 10.0497 18.6046C9.98182 18.4639 9.98356 18.2997 10.0544 18.1605C10.1252 18.0213 10.257 17.9232 10.4106 17.8953C11.6861 17.6636 13.688 16.9579 14.488 14.8244C15.0506 13.3241 15.0002 11.8102 14.7715 10.5959C14.7445 10.4526 14.7814 10.3047 14.8725 10.1909C14.9636 10.0771 15.0998 10.0087 15.2455 10.0036C15.3155 10.0012 15.3858 10 15.4563 10Z"
        fill={active ? 'white' : 'currentColor'}
      />
    </svg>
  </span>
);
